// //connect to my LogisticsTool
// import axios from "axios";
// const instanceLogisticsTool = axios.create({
//   //per ora è localhost, da cambiare con quello online
//   //baseURL: "http://localhost:61932/api/"
//   baseURL: process.env.VUE_APP_API_URL
// });
// export default instanceLogisticsTool;

import axios from "axios";
import CustomInterceptors from "@/api/GAInterceptors";

const instanceLogisticsTool = axios.create({  
  baseURL: process.env.VUE_APP_API_URL
});

instanceLogisticsTool.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceLogisticsTool.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);
export default instanceLogisticsTool;
